import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;
  const router = inject(Router);

  const requiredRole = route.data['role'];
  if (!requiredRole) {
    return false;
  }

  if (!authenticated) {
    return router.parseUrl('/login');
  }

  const hasRequiredRole = (role: string): boolean => {
    return Object.values(grantedRoles.realmRoles).some((roles) => roles.includes(role));
  };

  if (hasRequiredRole(requiredRole)) {
    return true;
  }

  // User is authenticated but doesn't have required role
  return router.parseUrl('/access-denied');
};

export const authGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
